<template>
  <div class="full-player">
    <div
      class="play-con"
      @click.stop="tooglePaly"
      :style="{ cursor: isExamMode ? 'not-allowed' : 'pointer' }"
    >
      <img v-show="loading" src="@/assets/images/free-practice/loading.svg" class="loading-icon" />
      <img
        v-show="!loading && playing"
        src="@/assets/images/free-practice/pause-audio.svg"
        class="pause-icon"
      />
      <img
        v-show="!loading && !playing"
        src="@/assets/images/free-practice/play.svg"
        class="play-icon"
      />
    </div>
    <div class="progress-con" :style="{ cursor: isExamMode ? 'not-allowed' : 'pointer' }">
      <div class="duraction">
        <span>{{ presentDuration }} </span>
        <span>{{ duration }}</span>
      </div>
      <div class="progress-bc" @click="changeProgress" id="fullProgress">
        <div class="progress-line" :style="{ width: `${progress}%` }" />
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFile } from '@/utils/utils'
import { Howl } from 'howler'
export default {
  props: {
    soundUrl: {
      type: String,
      default: '',
    },
    fatherPause: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    isExamMode: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    fatherPause() {
      console.log('fatherPause!!!!!!!!!!!!!!!')
      this.progress = 0
      // this.$player.pause()
    },
  },
  mounted() {
    this.progress = 0
    let that = this
    var tempSound = new Howl({
      src: [this.soundUrl],
      onload: function () {
        that.duration = that.formatTime(Math.round(tempSound.duration())) // 输出音频的总时长
      },
    })
  },
  beforeDestroy() {
    if (!this.isExamMode) {
      this.$player.pause()
      cancelAnimationFrame(this.animationId)
    }
  },
  data() {
    return {
      beforeFn: null,
      progress: 0,
      loading: false,
      playing: false,
      progressR: 19.5,
      animationId: '',
      presentDuration: '0:00',

      duration: '0:00',
    }
  },
  methods: {
    formatTime(secs) {
      var minutes = Math.floor(secs / 60) || 0
      var seconds = secs - minutes * 60 || 0
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds
    },

    changeProgress(e) {
      if (this.isExamMode) {
        return
      }
      console.log(e, 'changeProgress')
      let fullProgress = document.getElementById('fullProgress')
      this.progress = ((e.offsetX / fullProgress.offsetWidth) * 100).toFixed(1)
      console.log(this.progress)
      let playFile = this.$player.file
      if (this.$player.file) {
        playFile = this.$player.file.replace('?format=mp3&bitrate=64k', '')
      }
      if (this.soundUrl == playFile) {
        this.$player.sound.seek(((this.progress / 100) * this.$player.sound.duration()).toFixed(12))
      }
      this.presentDuration = this.formatTime(Math.round(this.$player.sound.seek()))
    },
    onStep() {
      if (!this.soundUrl) return
      let seek = 0
      try {
        seek = this.$player.sound.seek()
      } catch (e) {
        console.log(e)
      }
      this.presentDuration = this.formatTime(Math.round(seek))
      this.progress = ((seek / this.$player.sound.duration()) * 100).toFixed(1)
      if (this.playing) {
        this.animationId = requestAnimationFrame(() => {
          this.onStep()
        })
      }
    },
    tooglePaly() {
      if (this.isExamMode) {
        return
      }
      var soundUrl = this.soundUrl || ''

      let playFile = this.$player.file
      if (this.$player.file) {
        playFile = this.$player.file.replace('?format=mp3&bitrate=64k', '')
      }
      if (soundUrl == playFile) {
        // // 正在播放进程中
        if (this.playing) {
          this.$player.sound.pause()
          this.playing = false
          this.loading = false
        } else {
          this.$player.sound.play()
          this.playing = true
          this.onStep()
        }
      } else {
        // 新地址初始化播放
        this.loading = true
        this.$player.play(soundUrl, '', {}, false, false, false)
        this.$player.onloaded = (e) => {
          this.onStep()
          this.playing = true
          this.loading = false
        }
        this.$player.onended = () => {
          console.log('onended change')
          this.playing = false
        }
        this.$player.onpaused = () => {
          this.playing = false
          this.loading = false
        }
        this.$player.onUnload = () => {
          this.playing = false
          this.loading = false
        }
        this.$player.onloaderrored = () => {
          this.playing = false
          this.loading = false
        }
      }

      this.$emit('clickRecordPlayer', this.index)
    },
  },
}
</script>
<style lang="scss" scoped>
.full-player {
  display: flex;
  align-items: center;
  width: 615px;
  height: 74px;
  background: #fafafb;
  border: 1px solid #efeff1;
  padding: 0 16px;
  border-radius: 12px;
}
.play-con {
  // cursor: pointer;
  width: 42px;
  height: 42px;
  line-height: 32px;
  background: #39b38e;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  position: relative;
  color: #fff;
  margin-right: 10px;
  .loading-icon {
    width: 24px;
    height: 24px;
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .pause-icon {
    width: 24px;
    height: 24px;
  }
  .play-icon {
    width: 13px;
    margin-left: 3px;
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
.simple-player-con::after {
  content: '';
  position: absolute;
  top: 0;
  width: 0;
  background: transparent;
  width: 32px;
  height: 32px;
}
.progress-con {
  flex: 1;

  // cursor: pointer;
  .progress-bc {
    width: 100%;
    background: #e7e7ed;
    border-radius: 60px;
    height: 10px;
    overflow: hidden;
    position: relative;
    margin-right: 24px;
    .progress-line {
      width: 0;
      height: 10px;
      background: #39b38e;
      height: 100%;
      border-radius: 60px;
    }
  }
}
.duraction {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 25px;
  font-weight: 600;
  color: #696974;
}

.activeOptionIcon {
  transform: rotate(180deg);
}

.rate-con {
  position: relative;

  .rate-settle {
    display: flex;
    align-items: center;

    min-width: 117px;
    cursor: pointer;
  }
  .sound-icon {
    width: 24px;
    height: 24px;
  }
  .rate-text {
    color: #6c6e7e;
    font-size: 16px;
    font-weight: 600;
    margin-left: 16px;
    margin-right: 4px;
    transition: all 0.2s ease-in-out;
  }
  .arrow-down-icon {
    width: 24px;
    height: 24px;
    transition: all 0.4s ease-out;
  }
  .selectRate {
    width: 88px;
    border: none;
  }
  .dropdown-con {
    position: absolute;
    bottom: -210px;
    background: #fff;
    box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%),
      0px 3px 14px 2px rgb(0 0 0 / 12%);
    width: 100px;
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }
  .activeDropdownCon {
    opacity: 1;
    z-index: 999;
    transition: opacity 281ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      transform 187ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
}

.dropdown-item {
  padding: 0 16px;
  height: 28px;
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  padding-left: 18px;
  font-size: 16px;
  font-weight: 500;
}
.dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.activeRateItem {
  color: #faae56;
  background: #efeff1;
  font-weight: 600;
}
.download-con {
  width: 35px;
  cursor: pointer;
  text-align: center;
  .download-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
